import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    input,
    ViewEncapsulation
} from '@angular/core';
import { LayoutService } from '@services';
import { Highlight, HighlightLoader } from 'ngx-highlightjs';
import { HighlightLineNumbers } from 'ngx-highlightjs/line-numbers';
import { TabsModule } from 'primeng/tabs';

export interface CodeSnippet {
    language: string;
    languageDisplayName?: string;
    code: string;
}

@Component({
    selector: 'app-code-snippets',
    imports: [Highlight, HighlightLineNumbers, TabsModule, NgTemplateOutlet],
    templateUrl: './code-snippets.component.html',
    styleUrl: './code-snippets.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'app-code-snippets'
    }
})
export class CodeSnippetsComponent {
    public readonly data = input.required<CodeSnippet[]>();

    private readonly layoutService = inject(LayoutService);
    private hljsLoader = inject(HighlightLoader);

    constructor() {
        effect(() => {
            const isDarkTheme = this.layoutService.isDarkTheme();
            const themePath = isDarkTheme
                ? 'highlightjs-themes/github-dark.min.css'
                : 'highlightjs-themes/github.min.css';

            this.hljsLoader.setTheme(themePath);
        });
    }
}
